module.exports = __webpack_public_path__ + "img/4.a95f6067.svg";